export const STALE_DEAD_UPLOAD_PURGE_KEY = 'maintenance:op-462:stale-dead-upload-purge:v1';
// The corrected upload processor finished deploying to production immediately before this cutoff.
export const STALE_DEAD_UPLOAD_CUTOFF_SECONDS = Date.parse('2026-07-13T20:18:00Z') / 1000;

function isStaleDeadUpload(record) {
  return record?.owner_type === 'optimistic_message' && record?.upload?.state !== 'completed';
}

function referencesAnyUpload(message, uploadIds) {
  return Array.isArray(message?.upload_ids) && message.upload_ids.some((uploadId) => uploadIds.has(uploadId));
}

export async function purgeStaleDeadUploads(database) {
  return database.transaction(
    'rw',
    database._fingerprints,
    database._pending_upload_blobs,
    database.media_attachments,
    database.messages,
    async () => {
      const completedPurge = await database._fingerprints.get(STALE_DEAD_UPLOAD_PURGE_KEY);
      if (completedPurge) {
        return { didRun: false, uploadCount: 0, messageCount: 0, blobKeyCount: 0 };
      }

      const staleUploads = (await database.media_attachments.where('written_at').below(STALE_DEAD_UPLOAD_CUTOFF_SECONDS).toArray()).filter(
        isStaleDeadUpload,
      );
      const staleUploadIds = new Set(staleUploads.map((upload) => upload.id));
      const staleMessages = staleUploadIds.size
        ? (await database.messages.where('id').startsWith('optimistic_').toArray()).filter((message) =>
            referencesAnyUpload(message, staleUploadIds),
          )
        : [];
      const blobKeys = staleUploads.map((upload) => (upload.workspace_id ? [upload.workspace_id, upload.id] : null)).filter(Boolean);

      if (staleMessages.length) await database.messages.bulkDelete(staleMessages.map((message) => message.id));
      if (blobKeys.length) await database._pending_upload_blobs.bulkDelete(blobKeys);
      if (staleUploads.length) await database.media_attachments.bulkDelete([...staleUploadIds]);

      const result = {
        didRun: true,
        uploadCount: staleUploads.length,
        messageCount: staleMessages.length,
        blobKeyCount: blobKeys.length,
      };

      await database._fingerprints.put({
        key: STALE_DEAD_UPLOAD_PURGE_KEY,
        hash: 'complete',
        updatedAt: Date.now(),
        ...result,
      });

      return result;
    },
  );
}
